import { getBill } from '@mews-commander/legacy-entities/src/ducks';
import { useCommanderSelector, useCommanderThunkDispatch } from '@mews-commander/utils';
import { AssociateBillDialog } from '../../../../../modules/billing/AssociateBillDialog';
import { getChangeBillAssociatedAccountDialogBillId } from '../../../../../modules/billing/ducks/changeAssociatedAccount';
import { closeDialog } from '../../../../../modules/dialog/reducer';
import { isDialogOpen } from '../../../../../modules/dialog/selectors';
import { CHANGE_BILL_ASSOCIATED_ACCOUNT_DIALOG_NAME } from '../Action/ChangeBillAssociatedAccountAction';

const ChangeBillAssociatedAccountActionDialog = () => {
    const dispatch = useCommanderThunkDispatch();
    const billId = useCommanderSelector((state) =>
        getChangeBillAssociatedAccountDialogBillId(state, { scope: CHANGE_BILL_ASSOCIATED_ACCOUNT_DIALOG_NAME })
    );
    const bill = useCommanderSelector((state) => getBill(state, { id: billId }));
    const handleCloseDialog = () => dispatch(closeDialog(CHANGE_BILL_ASSOCIATED_ACCOUNT_DIALOG_NAME));

    const active = useCommanderSelector((state) =>
        isDialogOpen(state, { name: CHANGE_BILL_ASSOCIATED_ACCOUNT_DIALOG_NAME })
    );

    if (!bill) {
        return null;
    }

    return <AssociateBillDialog scope={billId} bill={bill} active={active} closeDialog={handleCloseDialog} />;
};

export default ChangeBillAssociatedAccountActionDialog;
